<template>
  <div class="page-template">
    <div class="page-title">{{ title }}</div>
    <div>
      <el-form :model="form" :rules="rules" ref="form" class="setting-form" label-width="180px">
        <el-col :span="24">
          <el-form-item prop="phone" label="卡面卡号/手机号">
            <el-input v-model.trim="form.phone" @keyup.enter.native="search" clearable class="search-input"
                      @clear="clear" placeholder="请输入卡面卡号/手机号">
              <el-button type="primary" slot="append" @click="search">查询</el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-card class="box-card" v-loading="loading">
          <div class="form-item-title">会员卡信息</div>
          <el-col :span="8">
            <el-form-item prop="cardNum" label="卡面卡号">
              <el-input v-model="formInfo.cardNum" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="name" label="姓名">
              <el-input v-model="formInfo.name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="" label="手机号">
              <el-input v-model="formInfo.phone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="status" label="卡状态">
              <el-input v-model="formInfo.status" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="memberCategoryName" label="卡类型">
              <el-input v-model="formInfo.memberCategoryName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="storeName" label="开卡门店">
              <el-input v-model="formInfo.storeName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="balance" label="储值余额" class="form-item-style">
              <el-input v-model="formInfo.balance" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="givingMoney" label="赠送金额" class="form-item-style">
              <el-input v-model="formInfo.givingMoney" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="usableIntegral" label="剩余积分" class="form-item-style">
              <el-input v-model="formInfo.usableIntegral" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="createDttm" label="发卡时间">
              <el-input v-model="formInfo.createDttm" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="line"></div>
          </el-col>
          <el-col :span="24">
            <div class="form-item-title">积分操作</div>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="giveIntegral" label="本次增减积分">
              <el-input type="number" v-model="form.giveIntegral" class="numrule"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');" placeholder="请输入正整数"></el-input>
              <el-button type="primary" @click="submitData(20)">增加</el-button>
              <el-button type="primary" @click="submitData(30)">减少</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="remarks" label="备注">
              <el-input type="textarea" :rows="2" v-model="form.remarks"></el-input>
            </el-form-item>
          </el-col>
        </el-card>
      </el-form>
      <!--      <div class="foot">-->
      <!--        <el-button type="primary" @click="submitData">提交</el-button>-->
      <!--        <el-button @click="reset">重置</el-button>-->
      <!--      </div>-->
    </div>
  </div>
</template>
<script>
  import api from "../../../config/api";

  export default {
    data() {
      return {
        loading: false,
        formInfo: {
          cardNum: '',//卡号
          password: '',
          name: '',
          phone: '',
          status: '',
          usableIntegral: '',
          balance: '',
          storeId: '',
          createDttm: '',
          memberCategoryName: '',
          storeName: ''
        },
        form: {
          phone: '',
          id: '',
          giveIntegral: '',//积分
          remarks: '',
          payType: 10,
        },
        rules: {
          phone: [{required: true, message: '请输入卡面卡号或手机号', trigger: 'change'}],
          giveIntegral: [{required: true, pattern: this.$utils.reg.thanNum, message: '请输入合法积分', trigger: 'blur'}],
        },
        title: '',
        storeList: [],
      };
    },
    computed: {
      statusList() {
        return this.$utils.getCacheStatus('mbMember.status')
      },
    },
    created() {
    },
    mounted() {
      this.title = document.title;
      this.getStoreList()
    },
    methods: {
      // 获取门店
      getStoreList() {
        this.$axios.fetchPost(api.store.store + '/list',).then(res => {
          if (res.code == 200) {
            res.data.unshift({id: -1, name: "总部"})
            this.storeList = res.data
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        }).catch(err => {
          this.$message({type: 'error', message: '获取失败!'});
        })
      },
      // 查询
      search() {
        if (!this.form.phone) {
          this.$message({type: 'warning', message: '请输入卡面卡号或手机号!'});
          return false;
        }
        this.loading = true
        this.clear()
        this.$axios.fetchPost(api.member.mbMemberQuery, {phone: this.form.phone}).then(res => {
          if (res.code === 200) {
            if (res.data) {
              this.formInfo = res.data
              this.form.id = res.data.id
              this.formInfo.status = this.statusList.filter(v => v.id === res.data.status)[0].label
            }
          } else {
            this.$message.error('[' + res.code + ']' + res.errorMsg)
          }
        }).finally(() => {
          this.loading = false
        })
      },
      clear() {
        this.formInfo = {}
        this.form.id = ''
        this.form.giveIntegral = ''
        this.form.remarks = ''
        this.form.payType = 10
      },
      // 重置
      reset() {
        this.form = {}
        this.$refs.form.resetFields()
      },
      // 提交
      submitData(val) {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (this.form.giveIntegral && Number(this.form.giveIntegral) === 0) {
              this.form.giveIntegral = '';
              this.$message.error('请输入正确积分');
              return;
            }
            if (val === 30) {
              if (Number(this.form.giveIntegral) - Number(this.formInfo.usableIntegral) > 0) {
                this.$message.warning('您本次减少的积分已超过剩余积分')
                this.form.giveIntegral = ''
              } else {
                this.save(val)
              }
            } else {
              this.save(val)
            }
          } else {
            return false
          }
        })
      },
      save(val) {
        this.$confirm((val === 20) ? '确认增加？' : '确认减少？')
          .then(_ => {
            this.$loading({text: '提交中，请稍后。。。'})
            this.form.businessType = val
            this.$axios.fetchPost(api.member.fluctuate, this.form).then(data => {
              if (data.code === 200) {
                if (data.data) {
                  this.search()
                }
                this.$notify({
                  type: "success",
                  title: '提交操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({type: 'success', message: '操作成功'});
              } else {
                this.$message({type: 'error', message: data.errorMsg});
              }
            }).catch((err) => {
              this.$message({message: '请求失败', type: 'error'});
            }).finally(() => {
              this.$loading({}).close()
            })
          })
          .catch(_ => {
          });
      },
    }
  };
</script>
<style scoped>
  .page-template {
    padding: 16px 30px;
  }

  .page-title {
    text-align: center;
    padding-bottom: 10px;
  }

  .form-item-title {
    padding-bottom: 10px;
    font-weight: bold;
  }

  .box-card {
    padding-bottom: 20px;
  }

  .line {
    border-top: 1px dashed #e0dddd;
    margin-bottom: 20px;
  }

  .foot {
    padding: 20px;
    text-align: center;
  }

  /*去掉箭头*/
  /deep/ .numrule input::-webkit-outer-spin-button,
  /deep/ .numrule input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }

  /deep/ .numrule input[type="number"] {
    -moz-appearance: textfield;
  }

  /*单条搜索后面跟的搜索按钮*/
  .search-input {
    width: 280px;
    line-height: normal;
  }

  >>> .el-input-group__append, .el-input-group__prepend {
    background-color: #458cff;
    color: #fff;
    border-color: #458cff;
    font-weight: 700;
  }

  >>> .el-input.is-disabled .el-input__inner {
    color: #999;
    background-color: #f9f9f9;
  }

  .form-item-style >>> .el-form-item__label {
    color: red;
  }
</style>




// WEBPACK FOOTER //
// src/page/member/integral/Fluctuate.vue